import React, { Component } from 'react';
import { Row, Col, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import EmployeesByTeam from './EmployeesByTeam';
import EmployeesByDepartment from './EmployeesByDepartment';
import Teams from './Teams';
import Departments from './Departments';
import PermissionWrapper from '../../auth/PermissionWrapper';
import EmployeesInactive from './EmployeesInactive';
import EmployeesEmailList from './EmployeesEmailList';

class EmployeeTabs extends Component {

    constructor(props) {
        super(props);

        this.state = {
            activeTab: 0,
        }
        this.cb = [];
    }

    componentDidMount = () => {
        this.props.log('EmployeeTabs.js/componentDidMount');
    }

    setCallback = (cb) => {
        this.props.log('EmployeeTabs.js/setCallback (cb)', cb);
        this.cb.push(cb);
    }

    render = () => {
        this.props.info('EmployeeTabs.js/render');
        return (

            <Row>
                <Col>
                    <Nav tabs className="px-0">
                        <NavItem>
                            <NavLink
                                className={classnames({ active: this.state.activeTab === 0 })}
                                onClick={() => { this.setState({ activeTab: 0 }); }}>
                                Employees By Team
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: this.state.activeTab === 3 })}
                                onClick={() => { this.setState({ activeTab: 3 }); }}>
                                Employees By Department
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: this.state.activeTab === 4 })}
                                onClick={() => { this.setState({ activeTab: 4 }); }}>
                                Inactive Employees
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: this.state.activeTab === 5 })}
                                onClick={() => { this.setState({ activeTab: 5 }); }}>
                                Email List
                            </NavLink>
                        </NavItem>
                        <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Edit Teams">
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: this.state.activeTab === 1 })}
                                    onClick={() => { this.setState({ activeTab: 1 }); }}>
                                    Edit Teams
                                </NavLink>
                            </NavItem>
                        </PermissionWrapper>
                        <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Edit Departments">
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: this.state.activeTab === 2 })}
                                    onClick={() => { this.setState({ activeTab: 2 }); }}>
                                    Edit Departments
                                </NavLink>
                            </NavItem>
                        </PermissionWrapper>
                    </Nav>
                    <TabContent activeTab={this.state.activeTab} className="px-0 py-3 mx-0 mb-3 border-left border-right border-bottom activeInsideTab">
                        <TabPane tabId={0}>
                            <EmployeesByTeam {...this.props} />
                        </TabPane>
                        <TabPane tabId={3}>
                            <EmployeesByDepartment {...this.props} />
                        </TabPane>
                        <TabPane tabId={4}>
                            <EmployeesInactive {...this.props} />
                        </TabPane>
                        <TabPane tabId={5}>
                            <EmployeesEmailList {...this.props} />
                        </TabPane>
                        <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Edit Teams">
                            <TabPane tabId={1}>
                                <Teams
                                    teams={this.props.teams}
                                    getTeams={this.props.getTeams}
                                    log={this.props.log}
                                    info={this.props.info}
                                    isFieldNull={this.props.isFieldNull}
                                    addToast={this.props.addToast}
                                    clientToken={this.props.clientToken}
                                    userPermissions={this.props.userPermissions}
                                />
                            </TabPane>
                        </PermissionWrapper>
                        <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Edit Departments">
                            <TabPane tabId={2}>
                                <Departments
                                    departments={this.props.departments}
                                    getDepartments={this.props.getDepartments}
                                    log={this.props.log}
                                    info={this.props.info}
                                    isFieldNull={this.props.isFieldNull}
                                    addToast={this.props.addToast}
                                    clientToken={this.props.clientToken}
                                    userPermissions={this.props.userPermissions}
                                />
                            </TabPane>
                        </PermissionWrapper>
                    </TabContent>
                </Col>
            </Row>
        );
    }
}

export default EmployeeTabs;
